/** The value actions of the platform-notice page — one family, one links module (the detail-page
 *  value actions rule). Every href comes from `gridLinks`; `platformNoticeLinks.test.ts` proves
 *  each one lands on a real route. */
import type { GridLink } from '@/components/ValueActions/identity';
import { platformNoticesHref } from '@/utils/gridLinks';

/** A notice, opened for editing on its list page (`useEditIntent`). */
export const platformNoticeHref = (id: number) => platformNoticesHref({ edit: id });

/** A tenant named on a notice: "Platform notices for this operator" (every tenant's notices and
 *  those listing it). */
export const tenantGrid = (tenantId: number): GridLink => ({
  href: platformNoticesHref({ tenant: tenantId }),
  label: 'Platform notices for this operator',
});
